export const RESULT_OPTIONS = ['picked_up', 'no_response'];
